import React from 'react'
import styled from 'styled-components'
import { IStatSummary } from '../../../types/statistics.types'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 24px;
  }
`

const Header = styled.div``

const Title = styled.h2`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 20px;
	line-height: 114%;
	text-align: justify;
	color: #000;
	margin: 0 0 15px;

	@media(max-width: 530px ){
	font-size: 15px;
	margin: 0 0 10px;
	}
`

const DateRange = styled.p`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	line-height: 114%;
	text-align: justify;
	color: #8f8f8f;
	margin: 0;

	@media(max-width: 530px ){
		font-size: 12px;
	}

`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 280px);
	margin-left: auto;
  }

  @media (max-width: 530px) {
    grid-template-columns: 1fr;
	margin:0 auto;
  }
`

const CardDivider = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0 0px 16px;
  margin-bottom: 75px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #01924f;
    border-radius: 2px;
  }

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }

  @media(max-width: 530px){
    margin-bottom: 20px;
  }
`


const CardValue = styled.div`
  font-family: 'e-Ukraine-Head', sans-serif;
  font-weight: 700;
  font-size: 40px;
  color: #01924f;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    font-size: 32px;
  }

  @media (max-width: 768px) {
	font-size: 30px;
    margin-bottom: 12px;
  }

  @media(max-width: 530px) {
  font-size: 20px; 
  }
`

const CardValueSmall = styled.span`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	line-height: 99%;
	color: #555;
	margin-left: 6px;

	@media(max-width: 530px) {
	font-size: 14px;
	}
`


const CardLabel = styled.span`
  font-family: 'e-Ukraine-Head', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 99%;
  text-transform: uppercase;
  color: #555;

  @media (max-width: 1024px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

const CardValueContainer = styled.div`
 display: flex;
 align-items: center;
 gap: 10px;
`

interface SummaryCardProps {
	value: number | string
	label: string
	suffix?: string
}

const SummaryCard: React.FC<SummaryCardProps> = ({ value, label, suffix }) => (
	<CardDivider>
		<CardValueContainer>
			<CardValue>
				{typeof value === 'number' ? value.toLocaleString('uk-UA') : value}
			</CardValue>
			{suffix && <CardValueSmall>{suffix}</CardValueSmall>}
		</CardValueContainer>
		<CardLabel>{label}</CardLabel>
	</CardDivider>
)

interface Props {
	data: IStatSummary
	dateRange: string
}

export const SummaryCardsComponent: React.FC<Props> = ({ data, dateRange }) => {
	return (
		<Wrapper>
			<Header>
				<Title>Загальна інформація</Title>
				<DateRange>{dateRange}</DateRange>
			</Header>
			<Grid>
				<SummaryCard value={data.totalCalls} label='Кількість дзвінків' />
				<SummaryCard value={data.consultations} label='Надано консультацій' />
				<SummaryCard value={data.registered} label='Зареєстровано звернень' />
				<SummaryCard value={data.inWork} label='В роботі звернень' />
				<SummaryCard value={data.executed} label='Виконано звернень' />
				<SummaryCard
					value={data.repairWorks}
					label='Кількість ремонтних робіт'
					suffix='(в роботі)'
				/>
			</Grid>
		</Wrapper>
	)
}
